import * as React from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { classes, st } from './ErrorMessageWrapper.deprecated.st.css';
import { ErrorAppearance, ErrorMessageWrapperDataHooks, } from './types';
export const ErrorMessageWrapper = ({ className, children, visible = false, suffixText, 'data-hook': dataHook, messageId, message, errorAppearance = ErrorAppearance.TextOnly, lang, }) => {
    const getMessage = () => {
        return (React.createElement("div", { id: messageId, className: classes.message, "data-hook": ErrorMessageWrapperDataHooks.Message },
            React.createElement(ErrorSmall, { className: classes.icon, "aria-hidden": true }),
            message));
    };
    return (React.createElement("div", { className: st(classes.root, { visible, errorAppearance }, className), "data-hook": dataHook, lang: lang },
        children,
        visible &&
            (suffixText ? (React.createElement("div", { className: classes.messageWithSuffix },
                getMessage(),
                suffixText)) : (getMessage()))));
};
//# sourceMappingURL=ErrorMessageWrapper.js.map